import makeApiRequest from './makeApiRequest';

const getSalesTotal = () => {
	const getApiRequest = makeApiRequest('GET');

	const acquireSalesTotal = async (apiBase: string) => getApiRequest(`${apiBase}/api/fair/total`, {});

	return [acquireSalesTotal];
};

export default getSalesTotal;
